import React, { useEffect, useState } from 'react'
import QrHeader from '../../components/QrCode/QrHeader';
import AmoutToPay from '../../components/QrCode/AmoutToPay';
import clsx from 'clsx';
import stylesQrCom from '../../components/QrCode/qrcom.module.css';
import ScannerFile from '../../components/QrCode/ScannerFile';
//import { useInitiateSubscriptionCheckout } from '../../api/initiateCheckout';
import { useCreateCheckoutOrder } from '../../api/createCheckoutOrder';
import { useSubscriptionPaymentStore } from '../../storage/subscriptionPaymentStore';
import { useGetOrderStatus } from '../../api/getOrderStatus';

//import checkoutResponse from '../../utils/data/initialCheckout.json';
//import createOrderResponse from '../../utils/data/createOrder.json';
import ErrorPageNew from '../../components/ErrorPage/NewError';
import Loader from '../../components/Loader';
import InitialCheckoutLoader from '../../components/Loader/InitialCheckoutLoader';
import InitialOrderLoader from '../../components/Loader/InitialOrderLoader';
import { useTokenStore } from '../../storage/tokenState';
import { NAVIGATION_ROUTES } from '../../constant';
import { Navigate, useNavigate } from 'react-router-dom';
import { CT_PARAMS } from '../../analytics/trackerEvents/cleverTap/parameters';
import { CLEVERTAP_EVENTS } from '../../analytics/trackerEvents/cleverTap/events';
import { trackCleverTapEvent } from '../../utils/cleverTapHelper';
import { GA_EVENTS, pushGAEvent } from '../../utils/gaHelper';


export default function QrCode() {

  const { token } = useTokenStore();

    const subscriptionPaymentDataCtx = useSubscriptionPaymentStore((state) => state.subscriptionPaymentDataCtx);
    const setSubscriptionPaymentDataCtx = useSubscriptionPaymentStore((state) => state.setSubscriptionPaymentDataCtx);
    const resetSubscriptionPaymentDataCtx = useSubscriptionPaymentStore((state)=>state.resetSubscriptionPaymentDataCtx)


         // Initiate checkout mutation
        // const { initiateCheckoutAsync, isLoading: isCheckoutLoading } = useInitiateSubscriptionCheckout();
         const { createOrderAsync, isLoading: isCreateOrderLoading } = useCreateCheckoutOrder();


         const [error, setError] = useState<boolean>(false);

         //const [isInitialCheckoutLoadingScreen, setIsInitialCheckoutLoadingScreen] = useState<boolean>(false);
         const [isCreateOrderLoadingScreen, setIsCreateOrderLoadingScreen] = useState<boolean>(false);
         const { token: userToken } = useTokenStore();
         const { getOrderStatus } = useGetOrderStatus();
         const navigate = useNavigate();

        /// console.log('initalCheckoutData dummy data', checkoutResponse);


      useEffect(() => {
        console.log('userToken in qr code', userToken.accessToken);
      }, [userToken]);

useEffect(() => {
  const userId = token?.zupeeUserId?.toString() || '';
  trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_QR_CODE_SCREEN_VIEW, {
    [CT_PARAMS.USER_ID]: userId
  });
}, []);

// useEffect(() => {

//     if(subscriptionPaymentDataCtx.planAmountCtx < 1 && subscriptionPaymentDataCtx.planIdCtx !== 0){
//         //alert('Invalid plan amount or plan id');
//         //return;
//     }

//     const initalCheckoutData = async () => {
//         setIsInitialCheckoutLoadingScreen(true);
//     try {
//                    // Step 1: Initiate subscription checkout
               
//                    const checkoutResponse = await initiateCheckoutAsync({
//                     amount: subscriptionPaymentDataCtx.planAmountCtx,
//                      autoMandate: true,
//                      planId: subscriptionPaymentDataCtx.planIdCtx,
//                      referralCouponApplied: false,
//                      shouldFetchCustomerDetails: true
//                    });
                   
//                    if (!checkoutResponse?.response?.success || !checkoutResponse?.response?.data?.sessionId) {
//                      console.error('Failed to initiate checkout');
//                      setError(true);
//                    }
                    
//                   let instrumentType = 'qr_collect'; // Default fallback

//                   let upiLogos: any[] = [];
//                    const upiWidgetOR = checkoutResponse?.response?.data?.paymentConfigData.find(
//                     (widget: any) => widget.widgetSubType === 'QR_UPI'
//                   );
//                   if (upiWidgetOR && upiWidgetOR.upiLogos && upiWidgetOR.upiLogos.length > 0) {
//                     upiLogos = [...upiLogos, ...upiWidgetOR.upiLogos];
//                   }

//                   let scannerText = '';
//                   if (upiWidgetOR && upiWidgetOR.description && upiWidgetOR.description.text) {
//                     scannerText = upiWidgetOR.description.text;
//                   }

//                   let messageData = '';
//                   if (upiWidgetOR && upiWidgetOR.messageData && upiWidgetOR.messageData.text) {
//                     messageData = upiWidgetOR.messageData.text;
//                   }

//                   let sharedData: any = {};
//                   if (upiWidgetOR && upiWidgetOR.sharedData) {
//                     sharedData = upiWidgetOR.sharedData;
//                   }

//                   let qrPollingConfig =  15000
//                   if (upiWidgetOR && upiWidgetOR?.qrPollingConfig?.pollingTimeMs != null) {
//                     const parsed = Number(upiWidgetOR?.qrPollingConfig?.pollingTimeMs);
//                     if (!Number.isNaN(parsed)) {
//                       qrPollingConfig = parsed;
//                     }
//                   }

//                    setSubscriptionPaymentDataCtx((prev: any) => ({ ...prev, sessionIdCtx: checkoutResponse?.response?.data?.sessionId, sessionTimestampCtx: checkoutResponse?.response?.data?.sessionTimestamp, upiLogosCtx: upiLogos, paymentConfigDataCtx: checkoutResponse?.response?.data?.paymentConfigData, instrumentTypeCtx: instrumentType, messageDataCtx: messageData, scannerTextCtx: scannerText, sharedDataCtx: sharedData, qrPollingConfigCtx: qrPollingConfig }));
//                    setIsInitialCheckoutLoadingScreen(false);
           
//                }   catch (error) {
//                    console.error('Error initiating checkout:', error);
//                    setError(true);
//                    setIsInitialCheckoutLoadingScreen(false);
//                }

//     }
//    // initalCheckoutData();
//     //console.log('subscriptionPaymentDataCtx in qr code', subscriptionPaymentDataCtx);
// }, []);

// Poll getOrderStatus API whenever orderIdCtx changes
useEffect(() => {
  const orderId = subscriptionPaymentDataCtx.orderIdCtx;
  if (!orderId) return;

  let attempts = 0;
  const maxAttempts = 20;
  const intervalMs = Number(subscriptionPaymentDataCtx.qrPollingConfigCtx || 15000) || 15000;
  let cancelled = false;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const poll = async () => {
    if (cancelled || attempts >= maxAttempts) {
      // After max attempts, treat as failure and redirect
      navigate(NAVIGATION_ROUTES.REFERRAL_PAYMENT_FAILED, {
        state: { orderId },
        replace: true,
      });
      return;
    }

    attempts += 1;

    try {
      const response = await getOrderStatus({ orderId, merchantName: subscriptionPaymentDataCtx.pgNameCtx });
      console.log('getOrderStatus response in QR page:', response);

      const status =
        response?.orderStatus ||
        response?.response?.data?.status ||
        'PENDING';

      if (status === 'SUCCESS' || status === 'success' || status === 'Success') {
        if (!cancelled) {
          pushGAEvent(GA_EVENTS.TRIAL_PAYMENT_SUCCESS, {
            order_id: orderId,
            amount: subscriptionPaymentDataCtx.planAmountCtx, 
            user_id: token?.zupeeUserId?.toString() || ''
          });
         const timer = setTimeout(() => {
          
            navigate(NAVIGATION_ROUTES.REFERRAL_SUBSCRIBED, {
              state: { orderId },
              replace: true,
            });
          }, 1000);
          return () => clearTimeout(timer);
        }
        return;
      }

      if (status === 'FAILED' || status === 'failed' || status === 'Failed') {
        if (!cancelled) {
          navigate(NAVIGATION_ROUTES.REFERRAL_PAYMENT_FAILED, {
            state: { orderId },
            replace: true,
          });
        }
        return;
      }

      // status is PENDING or unknown – schedule next poll if under maxAttempts
      if (!cancelled && attempts < maxAttempts) {
        timeoutId = setTimeout(poll, intervalMs);
      } else if (!cancelled) {
        // After exhausting attempts, navigate to session expire
        navigate(NAVIGATION_ROUTES.REFERRAL_SESSION_EXPIRE, {
          state: { orderId },
          replace: true,
        });
      }
    } catch (err) {
      console.error('Error fetching order status in QR page:', err);
      if (!cancelled && attempts < maxAttempts) {
        timeoutId = setTimeout(poll, intervalMs);
      } else if (!cancelled) {
        navigate(NAVIGATION_ROUTES.REFERRAL_PAYMENT_FAILED, {
          state: { orderId },
          replace: true,
        });
      }
    }
  };

  poll();

  return () => {
    cancelled = true;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };
}, [subscriptionPaymentDataCtx.orderIdCtx, subscriptionPaymentDataCtx.qrPollingConfigCtx, getOrderStatus, navigate]);

useEffect(() => {
    const createCheckoutOrder = async () => {
         // Step 3: Create checkout order
         
         if(subscriptionPaymentDataCtx.sessionIdCtx){
         setIsCreateOrderLoadingScreen(true);
         try {
            const orderResponse = await createOrderAsync({
                amount: subscriptionPaymentDataCtx.planAmountCtx,
                constraintId: subscriptionPaymentDataCtx.sessionIdCtx,
                instrumentType: subscriptionPaymentDataCtx.instrumentTypeCtx,
                isNewSavedCard: false,
                paymentMode: 'QR_UPI'
            });

            //const orderResponse = createOrderResponse;

            if (!orderResponse?.response?.success) {
                console.error('Failed to create checkout order');
                setError(true);
              }

              setSubscriptionPaymentDataCtx((prev: any) => ({ ...prev, orderIdCtx: orderResponse?.response?.data?.orderId, orderTimestampCtx: orderResponse?.response?.data?.expiryData?.timestamp, orderPgNameCtx: orderResponse?.response?.data?.pgName, orderMandateFlowDataCtx: orderResponse?.response?.data?.qrUrl, pgNameCtx: orderResponse?.response?.data?.pgName }));
              setIsCreateOrderLoadingScreen(false);

            //console.log('orderResponse', orderResponse);
        } catch (error) {
            console.error('Error creating checkout order:', error);
            setError(true);
            setIsCreateOrderLoadingScreen(false);
        }

    }

    };
    createCheckoutOrder();
}, [subscriptionPaymentDataCtx.sessionIdCtx]);



useEffect(() => {
    console.log('subscriptionPaymentDataCtx in qr code', subscriptionPaymentDataCtx);
}, [subscriptionPaymentDataCtx]);

if(subscriptionPaymentDataCtx.planAmountCtx === 0 && subscriptionPaymentDataCtx.planIdCtx === 0){
  return <Navigate to={NAVIGATION_ROUTES.REFERRAL_SUBSCRIPTION_PAYMENT} replace />
}

if(error){
  resetSubscriptionPaymentDataCtx();
    return <ErrorPageNew orderFailed={true} title="Something went wrong." subtitle="Don't worry. Lets try again" buttonText="Retry" />
}

if(!userToken.accessToken){
    return <Navigate to={NAVIGATION_ROUTES.REFERRAL_SIGNUP} replace />
}

// if(isInitialCheckoutLoadingScreen) {
//     return <InitialCheckoutLoader />
// }

if(isCreateOrderLoadingScreen) {
    return <InitialOrderLoader />
}

const updateSeesionExpireTime = (diff: number) => {
    console.log('updateSeesionExpireTime in qr code', diff);
}

  return (
    <main className={clsx(stylesQrCom.fontFamilyNotoSans, stylesQrCom.bgcolor, stylesQrCom.hv100)}>
         <QrHeader title="Scan QR to pay" clearStorePaymentOrder={resetSubscriptionPaymentDataCtx}/>
        <div className={clsx(stylesQrCom.container, stylesQrCom.flexStyle, stylesQrCom.flexDirecColumn, stylesQrCom.gap10, stylesQrCom.martop10)}>           
            <AmoutToPay title="Amount to pay" amount={`+₹${subscriptionPaymentDataCtx?.planAmountCtx}`} safeToUse="Safe to use" />
            <ScannerFile 
            topSpaceClass="martop20" 
            bottomSpaceClass="marbottom20"
            expiryShow={true}
            expireinTitle="expiry in"
            expireinValue={subscriptionPaymentDataCtx?.orderTimestampCtx}
            scannerText={subscriptionPaymentDataCtx?.scannerTextCtx}
            scannerbox={true}
            paymentIconsShow={true}
            paymentConsentText={subscriptionPaymentDataCtx?.messageDataCtx}
            shareFeatureShow={true}
            upiLogos={subscriptionPaymentDataCtx.upiLogosCtx}
            updateSeesionExpireTime={updateSeesionExpireTime}
            />
        </div>

    </main>
  )
}
